
import React from "react";
import { TextField, TextArea, ImageUpload } from "../controllers/addDemandcontrollers";
import { useFormikContext } from "formik";

const DnsFields = React.memo(({ index }) => {
        const { values, setFieldValue } = useFormikContext();

    return (
        <>
            <TextField
                label="How Many DNS"
                name={`info.${index}.dns_number`}
                type="number"
                placeholder="How Many DNS"
            />
            <div className="flex-item">
                <TextArea
                    label={"Additional Information"}
                    id="description"
                    name={`info.${index}.comment`}
                    placeholder="Optional notes..."
                    rows={3}
                    maxlength={`${values?.info?.[index]?.comment?.length}/1000 characters`}
                />
            </div>
            <ImageUpload
                label="Supporting Attachments"
                optional={false}
                name={`info.${index}.files`}
                value={values.info[index].files}
                setFieldValue={setFieldValue}
                displayMessage={"Upload limit: Up to 3 files, max 5 MB each."}
                maxFileSize={5 * 1024 * 1024}
                maxFileSizeTXT={"5MB"}
                combineFilesMaxSize={15 * 1024 * 1024}
                combineFilesMaxSizeTXT={"Combined file size exceeds the 15MB limit"}
                numOfFilesAllowToUpload={3}
                errorMessageForNumberOfFiles={"You can upload max 3 files."}
                acceptFileType={
                    {    
                    'image/*': ['.jpeg','.png',],
                    'application/pdf': ['.pdf'],
                    'application/vnd.ms-excel': ['.xls',],
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':['.xlsx'],
                    'application/msword':['.doc'],
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document':['.docx']
                    }
                }
            />
        </>
    );
});

export default DnsFields;
